import img10 from './Rehabilitacion/img10.jpg'
import img12 from './Rehabilitacion/img12.jpg'
import img33 from './Rehabilitacion/img33.jpg'
import img34 from './Rehabilitacion/img34.jpg'
import img36 from './Rehabilitacion/img36.jpg'
import img35 from './Rehabilitacion/img35.jpg'
import img37 from './Rehabilitacion/img37.jpg'
import img64 from './EquipoMedico/img64.jpg'
import img69 from './EquipoMedico/img69.jpg'
import { Footer } from './Footer'
import React, { Component } from 'react'
import { Card, Row, Col, Container } from 'react-bootstrap'
import { Navigation } from './Navigation'

export class Encamamiento extends Component {
    render() {
        const imagenes = [
            img33, img36, img34, img37, img35, img64, img10, img12, img69
        ];

        return (
            <div>
                <Navigation />
                <Container fluid className="px-4">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Encamamiento</h1>
                        </Col>
                    </Row>
                    
                    {/* Cambiamos a lg={2} para que las imágenes sean gigantes.
                      En pantallas grandes solo habrá 2 por fila.
                    */}
                    <Row xs={1} md={2} lg={2} className="g-4 text-center">
                        {imagenes.map((imagen, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow border-0">
                                    <Card.Body className="p-2"> 
                                        <Card.Img 
                                            variant="top" 
                                            src={imagen} 
                                            style={{ 
                                                height: '550px', 
                                                width: '100%',
                                                objectFit: 'contain'
                                            }} 
                                        />
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}